import { ReactNode, createContext, useContext } from 'react';

interface InboxNotificationContextType {
  onClose: () => void;
}

const InboxNotificationContext =
  createContext<InboxNotificationContextType | null>(null);

export function InboxNotificationProvider({
  children,
  onClose,
}: {
  children: ReactNode;
  onClose: () => void;
}) {
  return (
    <InboxNotificationContext.Provider value={{ onClose }}>
      {children}
    </InboxNotificationContext.Provider>
  );
}

export function useInboxNotificationContext() {
  const context = useContext(InboxNotificationContext);
  if (!context) {
    throw new Error(
      'useInboxNotificationContext must be used within an InboxNotificationProvider'
    );
  }
  return context;
}
